import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { mergeMap } from "rxjs/operators";
import { AuthenticationService } from "../../../access/shared/authentication/authentication.service";
import { UserToken } from "../../../access/shared/token/token";
import { Config } from "../../../config/config";
import { ConfigService } from "../../../config/config.service";
import { ChangePasswordRequest } from "./change-password-request";
import { Profile } from "./profile";

@Injectable({
  providedIn: "root"
})
export class ProfileService {

  constructor(
    private config: ConfigService,
    private http: HttpClient,
    private authenticationService: AuthenticationService
  ) {
  }

  private getConfig(): Observable<Config> {
    return this.config.getConfig();
  }

  public changePassword(request: ChangePasswordRequest): Observable<Object> {
    return this.getConfig().pipe(
      mergeMap(conf => {
        return this.http.patch(conf.apiPoint + this.replaceUserId(conf.changePassword), request);
      })
    );
  }

  private replaceUserId(input: string) {
    return input.replace('{user}', this.authenticationService.getUserToken().id + "");
  }

  public patchProfile(profile: Profile): Observable<Profile> {
    return this.getConfig().pipe(
      mergeMap(conf => {
        return this.http.patch<Profile>(conf.apiPoint + this.replaceUserId(conf.getUser), profile);
      })
    );
  }

  public getProfileOfUser(user: UserToken): Observable<Profile> {
    return this.getConfig().pipe(
      mergeMap(conf => {
        return this.http.get<Profile>(
          conf.apiPoint + conf.getUser.replace("{user}", user.id.toString())
        );
      })
    );
  }

  public getProfileOfCurrentUser(): Observable<Profile> {
    return this.getProfileOfUser(this.authenticationService.getUserToken());
  }
}
